<template>
  <!-- 自定义tabbar -->
  <div class="tabBar">
    <div v-if="datas.moduleType == 1">
      <div
        v-if="datas.iconList.filter((item) => item.isActive).length !== 0"
        class="tabbar"
      >
        <van-tabbar
          v-model="datas.active"
          :style="{ backgroundColor: datas.backgroundColor }"
          :fixed="false"
          :placeholder="true"
          :border="datas.isShowBorder"
          :active-color="datas.activeColor"
          :inactive-color="datas.inactiveColor"
          @change="handleTabChange"
        >
          <van-tabbar-item
            v-for="(item, index) in datas.iconList"
            :key="index"
            :name="item.iconText"
            :dot="item.isDot"
            v-if="item.isActive"
          >
            <span>{{ item.iconText }}</span>
            <template #icon="props">
              <div v-if="props.active">
                <i
                  v-if="item.iconPic.includes('iconfont')"
                  :class="item.iconPic"
                  style="font-size: 25px; margin-top: 10px"
                ></i>
                <van-icon
                  v-else
                  :name="item.iconPic"
                  :color="datas.activeColor"
                  size="28"
                />
              </div>
              <div v-else>
                <i
                  v-if="item.inactive.includes('iconfont')"
                  :class="item.inactive"
                  style="font-size: 25px"
                ></i>
                <van-icon
                  v-else
                  :name="item.inactive"
                  :color="datas.inactiveColor"
                  size="28"
                />
              </div>
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
      <div v-else>
        <van-tabbar
          v-model="datas.Highlight"
          :fixed="false"
          :placeholder="true"
          :border="datas.isShowBorder"
          :active-color="datas.activeColor"
          :inactive-color="datas.inactiveColor"
          @change="handleDefaultTabChange"
        >
          <van-tabbar-item icon="search" name="home">标签</van-tabbar-item>
          <van-tabbar-item icon="home-o">标签</van-tabbar-item>
          <van-tabbar-item icon="friends-o">标签</van-tabbar-item>
          <van-tabbar-item icon="setting-o">标签</van-tabbar-item>
          <van-tabbar-item icon="setting-o">标签</van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
    <!-- 底部导航栏样式2 -->
    <div v-if="datas.moduleType == 2">
      <div
        v-if="datas.iconList.filter((item) => item.isActive).length !== 0"
        class="tabbar_two"
      >
        <van-tabbar
          v-model="datas.active"
          :style="{ backgroundColor: datas.backgroundColor }"
          :fixed="false"
          :placeholder="true"
          :border="datas.isShowBorder"
          :active-color="datas.activeColor"
          :inactive-color="datas.inactiveColor"
          @change="handleTabChange"
        >
          <van-tabbar-item
            v-for="(item, index) in datas.iconList"
            :key="index"
            :name="item.iconText"
            :dot="item.isDot"
            v-if="item.isActive"
          >
            <span>{{ item.iconText }}</span>
            <template #icon="props">
              <div v-if="props.active">
                <i
                  v-if="item.iconPic.includes('iconfont')"
                  :class="item.iconPic"
                  style="font-size: 25px"
                ></i>
                <van-icon
                  v-else
                  :name="item.iconPic"
                  :color="datas.activeColor"
                  size="28"
                />
              </div>
              <div v-else>
                <i
                  v-if="item.inactive.includes('iconfont')"
                  :class="item.inactive"
                  style="font-size: 25px"
                ></i>
                <van-icon
                  v-else
                  :name="item.inactive"
                  :color="datas.inactiveColor"
                  size="28"
                />
              </div>
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
      <div v-else>
        <van-tabbar
          v-model="datas.Highlight"
          :fixed="false"
          :placeholder="true"
          :border="datas.isShowBorder"
          :active-color="datas.activeColor"
          :inactive-color="datas.inactiveColor"
          @change="handleDefaultTabChange"
        >
          <van-tabbar-item icon="search" name="home">标签</van-tabbar-item>
          <van-tabbar-item icon="home-o">标签</van-tabbar-item>
          <van-tabbar-item icon="friends-o">标签</van-tabbar-item>
          <van-tabbar-item icon="setting-o">标签</van-tabbar-item>
          <van-tabbar-item icon="setting-o">标签</van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
    <div v-if="datas.moduleType == 3">
      <!-- 自定义tabbar 保留你所有原有属性 -->
      <van-tabbar
        v-model="datas.active"
        :style="{ backgroundColor: datas.backgroundColor }"
        :fixed="false"
        :placeholder="true"
        :border="false"
        :active-color="datas.activeColor"
        :inactive-color="datas.inactiveColor"
        @change="handleTabChange"
        class="custom-tabbar"
      >
        <van-tabbar-item
          v-for="(item, index) in datas.iconList"
          :key="index"
          :name="item.iconText"
          :dot="item.isDot"
          :class="{ 'middle-tab-item': index === midIndex }"
        >
          <span>{{ item.iconText }}</span>
          <template #icon="props">
            <div
              v-if="props.active"
              :class="{ 'center-icon-active': index === midIndex }"
            >
              <i
                v-if="item.iconPic.includes('iconfont')"
                :class="item.iconPic"
                :style="
                  index === midIndex ? 'font-size: 30px' : 'font-size: 25px'
                "
              ></i>
              <van-icon
                v-else
                :name="item.iconPic"
                :color="datas.activeColor"
                :size="index === midIndex ? 12 : 28"
              />
            </div>
            <div v-else>
              <i
                v-if="item.inactive.includes('iconfont')"
                :class="item.inactive"
                :style="
                  index === midIndex ? 'font-size: 30px' : 'font-size: 25px'
                "
              ></i>
              <van-icon
                v-else
                :name="item.inactive"
                :color="datas.inactiveColor"
                :size="index === midIndex ? 32 : 28"
              />
            </div>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
import componentProperties from "@/utils/componentProperties"; // 组件数据
export default {
  name: "tabbar",
  props: {
    datas: Object,
    disabled: Boolean,
  },
  data() {
    return {
      pageComponents: Array.from(componentProperties.values())
    };
  },

  created() {
    this.datas.isShowBorder = this.$utils.strToBool(this.datas.isShowBorder)
    console.log(this.datas, "--------------tabbar底部导航栏组件挂载");
    document.querySelector(".phone-container").style.cssText =
      "padding-bottom: 50px";
    // 当iconList有值时，更新Vuex中的数据
    // if (this.datas && this.datas.iconList && this.datas.iconList.length > 0) {
    //   console.log("默认拖拽了底部导航栏");
    //   // 构建完整的底部导航栏数据对象
    //   const tabbarData = {
    //     component: "tabbar",
    //     type: "tabbar",
    //     name: "底部导航栏",
    //     datas: this.datas,
    //     id: `tabbar_${this.$uuid()}`,
    //   };
    //   // 更新Vuex
    //   this.$store.commit("modules/SET_TABBAR_DATA", tabbarData);
    // }
  },

  mounted() {
    // 当datas.iconList有值时，将底部导航栏数据存储到Vuex
  },

  methods: {
    // 处理自定义导航项切换事件
    handleTabChange(name) {
      console.log("底部导航栏切换是否禁止了", this.disabled);
      // 如果是右侧面板区域的组件 禁止下一步
      if (this.disabled) return;
      this.datas.iconList.forEach((el) => {
        el.isShow = false;
        if (el.iconText === name) {
          el.isShow = true;
        }
      });
      // 更新active状态

      // 找到当前选中的导航项
      const activeTab = this.datas.iconList.find(
        (item) => item.iconText === name
      );
      console.log("tabbar子组件里底部导航栏切换:", name, this.datas, activeTab);
      console.log('底部导航栏切换后获取vuex中的底部导航栏数据', this.$store.state.modules.templateData, this.pageComponents)
      if (this.$store.state.modules.templateData.tabBar.setStyle) {
        const isMyComponet = this.$store.state.modules.templateData.tabBar.setStyle.iconList.find(item => item.iconName === '我的')
        const index = this.$store.state.modules.templateData.pages.findIndex(item => item.pageId === "page_user")
        this.$store.state.modules.templateData.pages[index].components[0] = this.pageComponents.find(item => item.component === "my")
        console.log('打印是否是我的', isMyComponet,index,this.$store.state.modules.templateData)
      }
      // const pageUserComponet = componentProperties.get("my");
      if (activeTab) {
        // 发送事件给父组件，包含当前选中的导航项信息
        this.$emit("tab-change", {
          name,
          index: this.datas.iconList.findIndex(
            (item) => item.iconName === name
          ),
          tab: activeTab,
          iconList: this.datas.iconList,
        });
        // this.$store.commit("SET_LSTName",this.datas.iconList.findIndex(item => item.iconText === name))
      }
    },

    // 处理默认导航项切换事件
    handleDefaultTabChange(name) {
      console.log("默认底部导航栏切换:", name);
      // 默认导航禁止跳转路由
      // // 发送事件给父组件，包含当前选中的导航项信息
      // this.$emit("tab-change", {
      //   name,
      //   index: ["home", "标签2", "标签3", "标签4", "标签5"].indexOf(name),
      //   tab: { iconName: name, iconText: "标签" },
      //   isDefault: true,
      // });
    },
  },

  computed: {
    // 原有计算属性，不用改，逻辑正确，完美计算中间索引
    midIndex() {
      // 3个项→1，5个项→2，4个项→1，2个项→1 自动适配所有长度
      return Math.floor((this.datas.iconList || []).length / 2);
    },
  },

  watch: {
    "datas.iconList": {
      handler(newVal, oldVal) {
        console.log("底部导航栏数据变化:", newVal, oldVal, this.datas.iconList);
        // 当iconList有值时，更新Vuex中的数据
      },
      deep: true,
    },
  },

  beforeDestroy() {
    document.querySelector(".phone-container").style.cssText =
      "padding-bottom: 0px";
  },
};
</script>

<style lang="scss" scoped>
.tabBar {
  width: 100%;
  position: relative;
  // position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 2;
}

::v-deep .tabbar_two {
  .van-tabbar {
    border-radius: 30px;
    height: 64px;
    .van-tabbar-item {
      border-radius: 30px;
      .van-tabbar-item__text {
        // padding-top: 8px;
      }
    }
  }
}
.tabbar {
  :deep(.van-tabbar) {
    height: 64px;
    .van-tabbar-item {
      .van-tabbar-item__text {
        // padding-top: 8px;
      }
    }
  }
  :deep(.van-tabbar-item--active) {
    // background-color: transparent !important;
  }
  ::v-deep .van-icon {
    width: 25px;
    height: 25px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
// 底部导航栏模块3覆盖样式
//  ============中间项的自定义样式 (全部在这里，重点！) ============
// 深度作用域，穿透vant的默认样式，因为是scoped必须加:deep()
.custom-tabbar {
  height: 64px;
  // 1. 中间项的核心样式 - 向上凸起+居中+高度自适应
  :deep(.van-tabbar-item.middle-tab-item) {
    background-color: #3282f6;
    color: #fff;
    border-radius: 50%;
    height: 76px;
    position: relative;
    top: -15px; // 向上凸起的距离，数值越大凸越高，可自定义
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // 让凸起的按钮不会被遮挡
    z-index: 10;
  }

  // 2. 中间项的图标外层容器 - 圆形背景+阴影+大小，视觉突出
  :deep(.middle-tab-item .van-tabbar-item__icon) {
    color: #fff;
    // width: 60px;
    // height: 60px;
    // border-radius: 50%; // 圆形
    // background-color: #ffffff; // 按钮底色，可改成你的datas.backgroundColor
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); // 轻微阴影增强立体感
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // margin-bottom: 5px;
  }

  // 3. 中间项的文字样式 - 选中/未选中都高亮，和图标呼应
  :deep(.middle-tab-item .van-tabbar-item__text) {
    font-size: 12px;
    // margin-top: 8px;
    font-weight: 500;
    color: #fff;
  }

  // 4. 中间项激活图标的背景色 (可选，比如选中后圆形按钮变色)
  :deep(.center-icon-active) {
    width: 60px;
    border-radius: 50%;
    // background-color: red; // 绑定你传入的激活色，自动适配
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
